// src/utils/isPrerender.ts
export const isPrerender =
  typeof window !== "undefined" &&
  (process.env.REACT_APP_PRERENDER === "1" ||
    navigator.userAgent.includes("ReactSnap") ||
    navigator.userAgent.includes("HeadlessChrome"));
